import React, {FunctionComponent} from 'react'
import {BulletPoint} from "@App/Components/common/BulletPoint";
import {CalendarCheckBenefitsIcon, CheckIcon, CogIcon, OutlineLocationIcon} from "@App/Components/common/Icons";
import {useSelector} from "react-redux";
import {State} from "@App/state";
import {useDates} from "@App/hooks/useDates";
import {useTranslation} from "react-i18next";
import {
    OrganizationHasSelectableBevSupport,
    OrganizationIsLeaseplanAndServiceIsAppointment,
    ServiceShouldDisplayBevOnCurrentList
} from "@App/utils/conditionals/combinations";
import {ServiceIsGlass} from "@App/utils/conditionals/services";
import {GarageHasNationwideService} from "@App/utils/conditionals/garages";

export const OrderSummary: FunctionComponent = () => {

    const {t} = useTranslation()

    const {formatDate} = useDates()

    const garage = useSelector((state: State) => state.orders.garage)
    const premiumServices = useSelector((state: State) => state.orders.premiumServices)
    const slot = useSelector((state: State) => state.orders.slot)
    const service = useSelector((state: State) => state.orders.service)
    const organization = useSelector((state: State) => state.orders.organization)
    const brand = useSelector((state: State) => state.orders.brand)
    const bevSupport = useSelector((state: State) => state.filters.bevSupport)

    return (
        <div
            className={"order-2 row-span-2 w-full md:w-80 h-fit ml-auto border border-primary rounded p-5 mb-3"}>
            <div className={"font-bold mb-3"}>{t('checkout.orderSummary.headline')}</div>
            {service && (
                <BulletPoint text={service.pivot.display_name ? service.pivot.display_name : service.name}>
                    <CogIcon className={'w-5 h-5'}/>
                </BulletPoint>
            )}
            {brand && (
                <BulletPoint text={t('filters.brand') + brand.name}>
                    <span className={'w-[20px]'}></span>
                </BulletPoint>
            )}
            {(OrganizationHasSelectableBevSupport(organization) && ServiceShouldDisplayBevOnCurrentList(service, organization)) && (
                <BulletPoint text={bevSupport ? t('Elektro-/Hybridmotor') : t('Verbrennungsmotor')}>
                    <span className={'w-[20px]'}></span>
                </BulletPoint>
            )}
            {garage && (
                <BulletPoint text={`${garage.name} - ${garage.street}, ${garage.postcode}, ${garage.city}`}>
                    <OutlineLocationIcon/>
                </BulletPoint>
            )}
            {slot && (
                <BulletPoint text={`${formatDate(slot.starts_at, 'EEEEEE, dd.MM.yyyy, HH:mm')} Uhr`}>
                    <CalendarCheckBenefitsIcon className={'w-5 h-5'}/>
                </BulletPoint>
            )}
            {premiumServices && (
                premiumServices.map(premiumService => (
                    <BulletPoint key={premiumService.id} text={premiumService.name}>
                        <CheckIcon primary className={'text-primary w-5 h-5'}/>
                    </BulletPoint>
                ))
            )}
            {OrganizationIsLeaseplanAndServiceIsAppointment(organization, service) && (
                <div className={'bg-white rounded-md mt-4 px-4 py-3 text-neutral-700'}>
                    <p className={"text-sm"}><b>Ersatzwagen:</b> Bitte kontaktieren Sie LeasePlan nach der Werkstattbuchung unter <a href={t('hotline.hotline-phone-link')}
                                                                                                                                     className={'text-neutral-700 no-underline font-normal'}>{t('hotline.hotline-phone')}</a> (Mo
                        - Do 8:00 - 18:00 Uhr und Fr 8:00 - 17:00 Uhr)
                    </p>
                </div>
            )}
            {ServiceIsGlass(service) && garage && GarageHasNationwideService(garage) &&(
                <div className={'bg-white rounded-md mt-4 px-4 py-3 text-neutral-700'}>
                    <p className={"text-sm"}>{t('bookingInformation.mobileGlassDisclaimer')}</p>
                </div>
            )}
        </div>
    )
}

